/* eslint-disable func-style, guard-for-in, no-var, no-loop-func */

/**
 * Method will fill form with data
 * Each element will get the value from the data object based on the element name
 * e.g. if there is a property formData.foo, then value of an element with name="foo"
 * will be set to value of this property
 *
 * @param string formSelector
 * @param array formData
 */
const fillFormWithData = function fillFormWithData(formSelector, formData) {
  for (var key in formData) {
    $(formSelector).find(`input[name=${key}], select[name=${key}]`).each(function callback() {
      const input = $(this);
      const type = input.attr('type');
      if (type === 'radio' || type === 'checkbox') {
        if (input.val() === formData[key]) input.prop('checked', true);
      } else {
        input.val(formData[key]);
      }
    });
  }
};

module.exports = fillFormWithData;
